var path = 'components/packages/tooltips/contentItemIntersectionTooltip.html';
var html = "<p style=width:150px>You do not have an access to solve the intersection conflicts. Please, unassign conflicted content sets from this content.</p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;